import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/ap/collectSign',
    name: 'CollectSign',
    component: () => import('@/views/pages/CollectSign')
  },
  {
    path: '/collectSignInfo',
    name: 'CollectSignInfo',
    component: () => import('@/views/pages/CollectSignInfo'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/collectSignImg',
    name: 'CollectSignImg',
    component: () => import('@/views/pages/CollectSignImg')
  },
  {
    path: '/ap/Brokeredlogin',
    name: 'Brokeredlogin',
    component: () => import('@/views/pages/BrokeredLogin')
  },
  {
    path: '/',
    name: 'index',
    redirect: '/homeMain',
    component: () => import('@/views/index'),
    children: [{
        path: 'homeMain',
        name: 'homeMain',
        component: () => import('@/views/pages/Home'),
        meta: { title: '首页', activeMenu: 'homeMain' }
      },
      {
        path: 'dealCenter',
        name: 'dealCenter',
        component: () => import('@/views/pages/DealCenter'),
        meta: { title: '公告信息', activeMenu: 'dealCenter' }
      },
      {
        path: 'down',
        name: 'down',
        component: () => import('@/views/pages/OperateMain'),
        meta: { title: '下载中心', activeMenu: 'down' }
      },
      {
        path: 'operateMain',
        name: 'operateMain',
        component: () => import('@/views/pages/OperateMain'),
        meta: { title: '操作流程', activeMenu: 'operateMain' }
      },
      {
        path: 'industryNews',
        name: 'industryNews',
        component: () => import('@/views/pages/IndustryNews'),
        meta: { title: '行业资讯', activeMenu: 'industryNews' }
      },
      {
        path: 'policyRegulation',
        name: 'policyRegulation',
        component: () => import('@/views/pages/IndustryNews'),
        meta: { title: '政策法规', activeMenu: 'policyRegulation' }
      },
      {
        path: 'industryDetails',
        name: 'industryDetails',
        component: () => import('@/views/pages/Content'),
        meta: { title: '行业资讯', activeMenu: 'industryNews' }
      },
      {
        path: 'policyDetails',
        name: 'policyDetails',
        component: () => import('@/views/pages/Content'),
        meta: { title: '政策法规', activeMenu: 'policyRegulation' }
      },
      {
        path: 'dealDetails',
        name: 'dealDetails',
        component: () => import('@/views/pages/Content'),
        meta: { title: '公告信息', activeMenu: 'dealCenter' }
      },
      {
        path: 'noticeDetails',
        name: 'noticeDetails',
        component: () => import('@/views/pages/Content'),
        meta: { title: '通知公告', activeMenu: 'homeMain' }
      },
      {
        path: 'downDetails',
        name: 'downDetails',
        component: () => import('@/views/pages/Content'),
        meta: { title: '下载中心', activeMenu: 'down' }
      },
      {
        path: 'operateDetails',
        name: 'operateDetails',
        component: () => import('@/views/pages/Content'),
        meta: { title: '操作流程', activeMenu: 'operateMain' }
      },
      {
        path: 'search',
        name: 'search',
        component: () => import('@/views/pages/Search'),
        meta: { title: '搜索', activeMenu: 'homeMain' }
      },
      {
        path: 'aboutUs',
        name: 'aboutUs',
        component: () => import('@/views/pages/aboutUs'),
        meta: { title: '关于我们', activeMenu: 'homeMain' }
      },
      {
        path: 'content',
        name: 'content',
        component: () => import('@/views/pages/detail'),
        meta: { title: '常见问题', activeMenu: 'homeMain' }
      }
    ]
  },
  {
    path: '/vip/:code',
    name: 'vipIndex',
    component: () => import('@/views/index')
  }
]
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, saveTop) { if (saveTop) { return { x: 0, y: 0 } } else { return { x: 0, y: 0 } } },
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js